import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { SHORTCUT_HELP } from "./useDocgenShortcuts";

interface ShortcutsCheatSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Sprint B — W6. Modal cheat-sheet shown on ``?``. Headless content
 * comes from :data:`SHORTCUT_HELP` so the help text stays in sync with
 * what :func:`useDocgenShortcuts` actually wires up.
 */
export function ShortcutsCheatSheet({ open, onOpenChange }: ShortcutsCheatSheetProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Tipkovni prečaci</DialogTitle>
          <DialogDescription>
            Brzo se kreći kroz dokumente bez odvajanja od tipkovnice.
          </DialogDescription>
        </DialogHeader>
        <ul className="grid gap-2">
          {SHORTCUT_HELP.map(({ key, desc }) => (
            <li
              key={key}
              className="flex items-center justify-between gap-3 rounded-md border border-stone-100 bg-stone-50 px-3 py-2"
            >
              <span className="text-[0.85rem] text-stone-700">{desc}</span>
              <kbd className="inline-flex min-w-[28px] items-center justify-center rounded border border-stone-300 bg-white px-2 py-0.5 font-mono text-[0.78rem] font-bold text-stone-700 shadow-sm">
                {key}
              </kbd>
            </li>
          ))}
        </ul>
        <div className="text-[0.75rem] text-stone-400">
          Prečaci ne rade dok je fokus u polju za unos.
        </div>
      </DialogContent>
    </Dialog>
  );
}
